export const injectedHomepageState = {
  state: {
    stickyVideoToClick: true,
    dtmSettings: window.digitalData,
    hasSkinInPage: true,
    enablePageIntersection: false,
    isVideoFinished: false,
    appendHomePage: true,
    isInitHomepageADV: true,
    targetPoint: undefined,
    hpHtmlSelectedDTM: '',
    hpUrl: '',
    currentPageUrl: '',
  },
  setState(key, value) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      this.state[key] = value;
    }
  },
  getState(key) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      return this.state[key];
    }
    return undefined;
  },
};
